import React from 'react';
import { Container, Carousel } from 'react-bootstrap';
import { FaQuoteLeft, FaStar } from 'react-icons/fa';
import { testimonials } from '../data/content';

const Testimonials = () => {
  return (
    <section id="testimonials" className="section">
      <Container>
        <div className="section-title">
          <h2>Testimonials</h2>
        </div>
        <Carousel className="testimonials-slider" indicators={true} interval={5000} touch wrap>
          {testimonials.map(testimonial => (
            <Carousel.Item key={testimonial.id}>
              <div className="testimonials-item">
                <div className="testimonial-avatar" aria-hidden="true">
                  {testimonial.client?.[0] || 'C'}
                </div>
                <div className="quote-icon mb-4">
                  <FaQuoteLeft size={30} className="text-primary" />
                </div>
                <div className="mb-3">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <FaStar key={i} color="#f39c12" size={20} className="me-1" />
                  ))}
                </div>
                <p className="testimonial-content">"{testimonial.content}"</p>
                <div className="client">{testimonial.client}</div>
                <div className="text-muted">{testimonial.position}</div>
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </Container>
    </section>
  );
};

export default Testimonials;
